// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oath","newExpiryDate":"styles_newExpiryDate__3xYk_","footer":"styles_footer__1TVw7"};